<template>
  <div>
    <Head :title="form.name" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/products">Products</Link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ form.name }}</li>
      </ol>
    </nav>
    <h1>
      {{ form.name }}
    </h1>
    <trashed-message v-if="products.deleted_at" class="mb-6" @restore="restore"> This product has been deleted. </trashed-message>
    <div class="content-box">
      <form @submit.prevent="update">
        <ProductForm :form="form" />

        <div class="actions-toolbar d-flex justify-content-between">
          <button class="btn btn-outline-danger" tabindex="-1" type="button" @click="destroy">Delete Product</button>
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Update Product</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import ProductForm from './components/ProductForm'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    ProductForm,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    products: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.products.name,
        category: this.products.category,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/settings/products/${this.products.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this product?')) {
        this.$inertia.delete(`/settings/products/${this.products.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this product?')) {
        this.$inertia.put(`/settings/products/${this.products.id}/restore`)
      }
    },
  },
}
</script>
